'use client'

import { GiftCardReference } from '@/components/forms'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { useModals } from '@/lib/hooks'

interface GiftCardReferenceModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const GiftCardReferenceModal = ({
  open,
}: GiftCardReferenceModalProps) => {
  const { closeModal, closeAll } = useModals()

  return (
    <Dialog open={open}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('GIFT_CARD_REFERENCE')}
        size="lg"
      >
        <DialogHeader>
          <DialogTitle>Gift Card</DialogTitle>
          <DialogDescription>
            Please enter the barcode of the Gift Card
          </DialogDescription>
        </DialogHeader>

        {open && <GiftCardReference onClose={() => closeAll()} />}
      </DialogContent>
    </Dialog>
  )
}
